import { LoggableContentType } from '@app-types/PageType'
import { additionalStats } from '@components/Home/AddToStatsModal'
import { contentLibrary } from '@components/shared/consts'

export const getNameByPageType = (pageType: LoggableContentType | string): string =>
  contentLibrary.find((item) => item.type === pageType)?.name ||
  additionalStats.find((item) => item.type === pageType)?.name ||
  pageType // For custom stats, the name is the same as the type/id

export const getEstReadTime = (pageType: LoggableContentType): number =>
  contentLibrary.find((item) => item.type === pageType)?.estReadTime || 0